import { IWebsiteManagerPayload, IWebsiteStatus, IWebsiteURLType } from "../interfaces/website-manager-api.interface";
import { useFormContext } from "react-hook-form";
import { ControlledTextFieldWithIcon } from "Components/HookForm/ControlledTextFieldWithIcon";
import { VStack } from "Components/Layouts";
import { FormControl, InputLabel, Select, MenuItem, Grid, Typography } from "@mui/material";
import { Authority } from "static";
import { useState } from "react";
import { ColorX } from "static";

interface IProps {
  row?: IWebsiteManagerPayload;
  mode: "Add" | "Edit" | "Info";
}

export const WebsiteInfo = ({ mode, row }: IProps) => {
  const { control, setValue, getValues } = useFormContext<IWebsiteManagerPayload>();

  const [defaultURLType, setDefaultURLType] = useState(row?.urlSetting?.type || IWebsiteURLType.EXPLICIT);
  const [displayedUrl, setDisplayedUrl] = useState(getValues("urlSetting.url") || "");

  const accessible = Authority.IsAccessibleQ(`GPTQA.WebsiteManager`, 999, "WebsiteStatus");
  mode = !accessible && (row?.status == IWebsiteStatus.INDEXING || row?.status == IWebsiteStatus.DELETING) ? "Info" : mode;
  const isErrorMessage = row?.error_message ? row?.error_message : null;

  return (
    <VStack width={"100%"}>
      <Grid container spacing={2} sx={{ marginLeft: "30px", marginRight: "30px" }}>
        <Grid item xs={12} sm={10}>
          {mode != "Add" && <ControlledTextFieldWithIcon name="_id" label="ID" control={control} variant="outlined" fullWidth disabled />}
        </Grid>
        <Grid item xs={12} sm={mode != "Add" ? 8 : 10}>
          <ControlledTextFieldWithIcon name="alias" label="Website Name" control={control} variant="outlined" fullWidth disabled={mode == "Info"} />
        </Grid>
        <Grid item xs={12} sm={2}>
          {mode != "Add" && <ControlledTextFieldWithIcon name="status" label="Status" control={control} variant="outlined" fullWidth disabled />}
        </Grid>
        <Grid item xs={12} sm={10}>
          <ControlledTextFieldWithIcon
            name="urlSetting.url"
            label="Website URL"
            control={control}
            variant="outlined"
            fullWidth
            required
            rules={{ required: "Required" }}
            disabled={mode == "Info"}
            value={displayedUrl}
            multiline={mode == "Add" && defaultURLType == IWebsiteURLType.EXPLICIT}
            onChange={(event: any) => {
              setDisplayedUrl(event.target.value);
              setValue("urlSetting.url", event.target.value);
            }}
          />
        </Grid>
        {/* <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">URL Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              defaultValue={defaultURLType}
              label="urlSetting.type"
              disabled={mode == "Info"}
              onChange={(event: any) => {
                setValue("urlSetting.type", event.target.value as IWebsiteURLType);

                // handle URL change from explicit to *
                console.log("displayedUrl", displayedUrl);
                let updatedURL = displayedUrl;
                setDisplayedUrl(updatedURL);
                setValue("urlSetting.url", updatedURL);
              }}
            >
              <MenuItem value={IWebsiteURLType.IMPLICIT}>{IWebsiteURLType.IMPLICIT}</MenuItem>
              <MenuItem value={IWebsiteURLType.EXPLICIT}>{IWebsiteURLType.EXPLICIT}</MenuItem>
            </Select>
          </FormControl>
        </Grid> */}

        <Grid item xs={12} sm={5}>
          {mode != "Add" && <ControlledTextFieldWithIcon name="CREATED_AT" label="Created At" control={control} variant="outlined" fullWidth disabled />}
        </Grid>
        <Grid item xs={12} sm={5}>
          {mode != "Add" && <ControlledTextFieldWithIcon name="LASTMODIFIED" label="Last Modified Time" control={control} variant="outlined" fullWidth disabled />}
        </Grid>
        {isErrorMessage && (
          <Grid item xs={12} sm={10}>
            {mode != "Add" && <ControlledTextFieldWithIcon name="error_message" label="Error Message" control={control} variant="outlined" fullWidth disabled />}
          </Grid>
        )}
        {/* Google URL pattern */}
        <Grid item xs={12} sm={10}>
          {
            <Typography style={{ color: ColorX.GetColorCSS("Primary"), width: Infinity, fontSize: 14 }}>
              {/* Implicit (*) sites: It will search for all URLs beginning with example.com, such as www.mysite.com/* or www.example.com/docs* <br />
              Explicit site: It will only search for the single page, such as www.example.com/page.html/ or www.example.com/docs/ */}
              Please follow the URL pattern: <br />
              1. URL must ends with * <br />
              2. If URL does not have subpath, it should only ends with /* <br />
              3. If URL have subpath, it could ends with /* or * <br />
              <br />
              Example of valid URL: www.example.com/* or www.example.com/docs/* or www.example.com/docs* <br />
            </Typography>
          }
        </Grid>
      </Grid>
    </VStack>
  );
};
